import {Activity} from "../../types";
import {DataStore} from "../../DataStore";
import {BasePanelWidget} from "../../BasePanelWidget";
import {frontRouter} from "../../FrontRouter";

export class UiAddActivity extends BasePanelWidget{
    beforeIndex() {
        this.muAppendContent(`
            <div class="add-activity__list" mu="activityList#activityList:@foreach">
                <div class="add-activity__item" mu=":CommonListItem@item" mu-params="click:clickActivity">
                    <span mu-bind="name;icon|ifEmpty('blank')|prepend('icon-size--2rem icon-before--'):className"></span>            
                </div>
            </div>
        `);
    }

    setActivity(activity: Activity) {
        this.muParent.editActivity(activity);
        this.muRemoveSelf();
    }

    clickActivity(activity: Activity) {
        frontRouter.navPushSet('newJournalActivitySetActivity', { activityId: activity.id.toString() });
    }

    async afterIndex() {
        this.setTitle('Přidat');
        this.muBindData({
            activityList: await DataStore.get().getActivities()
        });
    }
}
